import React, { useEffect, useState } from 'react';
import { Font, View, Text, StyleSheet, Image } from '@react-pdf/renderer';
import SubjectFeedback from './subjectFeedback';

Font.register({
    family: 'Ubuntu',
    fonts: [
        {
            src: 'https://fonts.gstatic.com/s/questrial/v13/QdVUSTchPBm7nuUeVf7EuStkm20oJA.ttf',
        },
        {
            src: 'https://fonts.gstatic.com/s/questrial/v13/QdVUSTchPBm7nuUeVf7EuStkm20oJA.ttf',
            fontWeight: 'bold',
        },
        {
            src: 'https://fonts.gstatic.com/s/questrial/v13/QdVUSTchPBm7nuUeVf7EuStkm20oJA.ttf',
            fontWeight: 'normal',
            fontStyle: 'italic',
        },
    ],
});

const StudentSummaryPage = ({ subjectObjR1, subjectObjR2 = {}, subjectObjR3 = {}, isFirstPage }) => {
    useEffect(() => {
        // console.log("StudentSummaryPage1 called");
    }, []);


    return (
        <View style={[styles.container]}>
            {
                isFirstPage ?
                    <View style={[styles.header]}>
                        <View style={[styles.headerRow]}>
                        </View>
                        <View style={[styles.headerRow]}>
                            <Text style={[styles.textHeading, { color: 'darkorange' }]}>Part C</Text>
                        </View>
                        <View style={[styles.headerRow]}>
                            <Text style={[styles.textHeading, { color: 'black' }]}>Summary for the academic year</Text>
                        </View>
                    </View>
                    : null
            }
            <View style={[styles.main]}>
                <View style={[styles.subjectSection]}>
                    <SubjectFeedback
                        subjectObj={subjectObjR1}
                    />
                </View>
                <View style={[styles.subjectSection]}>
                    <SubjectFeedback
                        subjectObj={subjectObjR2}
                    />
                </View>
                <View style={[styles.subjectSection]}>
                    <SubjectFeedback
                        subjectObj={subjectObjR3}
                    />
                </View>
            </View>
            <View style={styles.dividerSection} >
                <View style={styles.divider} />
            </View>
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: "column",
    },
    header: {
        flex: 3,
        flexDirection: "column",
    },
    headerRow: {
        flex: 1,
        justifyContent: "center",
    },
    textHeading: {
        // marginTop: 100,
        fontSize: 16,
        fontWeight: "bold",
        textAlign: 'center',
        textTransform: 'uppercase',
        color: '#e36c0a',
        fontFamily: 'Helvetica-Bold',
        // borderRadius: 6,
        padding: 10,
        paddingTop: 30
    },
    main: {
        flex: 20,
        flexDirection: "column",
    },
    subjectSection: {
        flex: 1,
        flexDirection: "column",
        // border: '1px solid blue',
        margin: 10,
    },
    dividerSection: {
        flex: 1,
        flexDirection: "column",
    },
    divider: {
        backgroundColor: 'darkorange',
        width: '90%',
        height: 1,
        position: 'absolute',
        bottom: 30,
        left: '5%',
    },
});

export default StudentSummaryPage;